define('lib/util',['require','exports','module','underscore','jquery','backbone','services/auth/info','env'],function (require, exports) {
  'use strict';

  var _ = require('underscore'),
    $ = require('jquery'),
    DISABLED_CLASS = 'is-disabled',
    Backbone = require('backbone'),
    AuthInfo = require('services/auth/info'),
    authInfo = new AuthInfo(),
    Config = require('env');

  exports.mixin = function (target, module) {
    var safeModule = _.omit.apply(_, [module, 'mixed'].concat(_.keys(target)));
    _.extend(target.prototype, safeModule);
    if (module.mixed) {
      module.mixed.call(module, target, target.prototype);
    }
  };

  exports.before = function (original) {
    var decorators = [].slice.call(arguments, 1);
    original = original || function () {};
    return function () {
      var self = this,
        args = _.foldl(
          decorators,
          function (acc, fn) {
            return fn.apply(self, acc);
          },
          arguments
        );
      return original.apply(this, args);
    };
  };

  exports.bbinvoker = function (method) {
    var args = [].slice.call(arguments, 1);
    return function () {
      var newargs = [].slice.call(arguments);
      return this[method].apply(this, args.concat(newargs));
    };
  };

  exports.k = function (v) {
    return function () {
      return v;
    };
  };

  exports.onModelReady = function (model, fn, ctx) {
    if (model.isNew()) {
      model.once('sync', fn, ctx);
      model.fetch();
    } else {
      fn.call(ctx);
    }
  };

  exports.hexToRgba = function (hexColor, opacity) {
    var h = hexColor.replace('#', '');
    h = h.match(new RegExp('(.{' + h.length / 3 + '})', 'g'));

    for (var i = 0; i < h.length; i++) {
      h[i] = parseInt(h[i].length == 1 ? h[i] + h[i] : h[i], 16);
    }

    if (opacity !== undefined) {
      h.push(opacity);
    }

    return 'rgba(' + h.join(',') + ')';
  };

  exports.addHttpsToUrl = function (url) {
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  };

  exports.disableField = function ($target) {
    $target = $target instanceof $ ? $target : $($target);
    $target.prop('disabled', true).addClass(DISABLED_CLASS);
  };

  exports.enableField = function ($target) {
    $target = $target instanceof $ ? $target : $($target);
    $target.removeAttr('disabled').removeClass(DISABLED_CLASS);
  };

  exports.isFieldDisabled = function ($target) {
    $target = $target instanceof $ ? $target : $($target);
    return $target.hasClass(DISABLED_CLASS);
  };

  exports.isVariantAMP = function (variant) {
    return variant.get('platform') === 'amp';
  };

  exports.isAnyVariantAMP = function (variants) {
    if (!variants || !variants.models) {
      return false;
    }

    return _.some(variants.models, exports.isVariantAMP);
  };

  exports.getCustomAMPScript = function (customAMPScriptModel) {
    return customAMPScriptModel
      ? {
          url: customAMPScriptModel.get('customScriptURL'),
          content: customAMPScriptModel.get('customScriptContent'),
        }
      : {};
  };

  exports.hotPageReload = function () {
    Backbone.history.loadUrl(Backbone.history.fragment);

    return true;
  };

  exports.isPlatformAMP = function (app) {
    return app.options.platform === 'amp';
  };

  exports.getVariantIcon = function (platform) {
    /* jshint ignore:start */
    switch (platform) {
      case 'amp':
        return 'ed-icon-amp';
      case 'mobile':
        return 'ed-icon-mobile';
      case 'desktop':
      default:
        return 'ed-icon-monitor';
    }
    /* jshint ignore:end */
  };

  exports.generateRandom = function () {
    var numberOfInitialLetters = 5,
      charMap = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
      initialLetters;

    initialLetters =
      Array.apply(null, Array(numberOfInitialLetters))
        .map(function () {
          return charMap.charAt(Math.floor(Math.random() * charMap.length));
        })
        .join('') + '_';

    return initialLetters + Math.floor(Math.random() * Date.now()).toString(32);
  };

  exports.showAMPByCompany = function () {
    var groupId = authInfo.getGroupId();

    return !Config.groupsAllowedToAMP || _.contains(Config.groupsAllowedToAMP, groupId);
  };

  exports.copyToClipboard = function (text, cb) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text, cb);
      return;
    }
    navigator.clipboard.writeText(text).then(
      function () {
        cb && cb();
      },
      function (err) {
        console.error('Async: Could not copy text: ', err);
      }
    );
  };

  var fallbackCopyTextToClipboard = function (text, cb) {
    var textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy'),
        msg = successful ? 'successful' : 'unsuccessful';
      successful && cb && cb();
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  };

  exports.sanitizeString = function (str) {
    str || (str = '');

    str = str.replace(/^\d+/, '');

    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/[\s.-]/gm, '_');
  };

  exports.adjustTabs = function () {
    var tabWidth = $('.ed-single-tab:last').width();
    $('.js-nav-tabs').toggleClass('multi-tabs', tabWidth < 50);
  };
  exports.formatDate = function (date) {
    function zeroPad(n) {
      return ('00' + n).slice(-2);
    }
    return [date.getFullYear(), zeroPad(date.getMonth() + 1), zeroPad(date.getDate())].join('/');
  };
});

